export async function counter() {
    let counterElements = document.querySelectorAll('[data-counter]');

    if (counterElements && counterElements.length) {
        let { initCounter } = await import(/* webpackMode: "lazy" */ './counter.async.js');

        initCounter(counterElements);
    }
}
